// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2224":"9fc948f3e4f63785","4633":"0fdee65bbb0d6b3c","9704":"e66804a7d0ec835d"}[chunkId] + ".css";
};